import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox", "field", "wrapper"];

  connect() {
    this.sync();
  }

  toggle() {
    this.sync({ focus: true });
  }

  sync({ focus = false } = {}) {
    if (!this.hasCheckboxTarget || !this.hasFieldTarget || !this.hasWrapperTarget) {
      return;
    }

    const show = this.checkboxTarget.checked;
    // Hide the wrapper, not the input, so its margin collapses with it.
    this.wrapperTarget.classList.toggle("d-none", !show);

    if (!show) {
      // Stays enabled so the cleared value still submits and can overwrite.
      this.fieldTarget.value = "";
    } else if (focus) {
      this.fieldTarget.focus();
    }
  }
}
